/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FilterTypeConstants = {
    String: 'String',
    Boolean: 'Boolean',
    Date: 'Date',
    Identifier: 'Identifier',
    Number: 'Number'
} as const;
export type FilterTypeConstants = typeof FilterTypeConstants[keyof typeof FilterTypeConstants];


export function FilterTypeConstantsFromJSON(json: any): FilterTypeConstants {
    return FilterTypeConstantsFromJSONTyped(json, false);
}

export function FilterTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterTypeConstants {
    return json as FilterTypeConstants;
}

export function FilterTypeConstantsToJSON(value?: FilterTypeConstants | null): any {
    return value as any;
}

